<template>
  <div class="overflow-y-auto space-y-3 mb-6">
    <button
      v-for="template in elementTemplates"
      :key="template.type"
      class="w-full flex items-center gap-4 p-3 rounded-2xl hover:bg-primary-50 transition-colors text-right border border-surface-100 hover:border-primary-200 group"
      @click="handleAddElement(template)"
    >
      <div class="bg-surface-50 text-surface-500 group-hover:bg-primary-100 group-hover:text-primary-600 p-3 rounded-xl transition-colors">
        <i :class="template.icon" class="text-2xl"></i>
      </div>
      <div>
        <div class="font-semibold text-surface-800">{{ template.label }}</div>
        <div class="text-xs text-surface-500 mt-0.5">{{ template.desc }}</div>
      </div>
    </button>
  </div>
</template>

<script setup lang="ts">

import { ConsentFormElementTypeEnum, IConsentFormElement } from '@torim-app/types';

const emit = defineEmits(['selectedElement'])

const elementTemplates = [
  {
    type: ConsentFormElementTypeEnum.ReadOnly,
    icon: 'pi pi-align-right',
    label: 'בלוק טקסט',
    desc: 'טקסט קריאה בלבד להנחיות או תנאים',
  },
  {
    type: ConsentFormElementTypeEnum.ShortText,
    icon: 'pi pi-pencil',
    label: 'שדה טקסט',
    desc: 'שדה להזנת טקסט חופשי',
  },
  {
    type: ConsentFormElementTypeEnum.Checkboxes,
    icon: 'pi pi-check-square',
    label: 'תיבות סימון',
    desc: 'בחירה מרובה מרשימה',
  },
  {
    type: ConsentFormElementTypeEnum.MultipleChoice,
    icon: 'pi pi-circle',
    label: 'בחירה יחידה',
    desc: 'בחירת אפשרות אחת מתוך רשימה',
  },
  {
    type: ConsentFormElementTypeEnum.Signature,
    icon: 'pi pi-pen-to-square',
    label: 'חתימה',
    desc: 'לכידת חתימה דיגיטלית',
  },
  {
    type: ConsentFormElementTypeEnum.Image,
    icon: 'pi pi-image',
    label: 'תמונה',
    desc: 'העלאת תמונה שתישמר בתיק הלקוח',
  },
];

const handleAddElement = (template: (typeof elementTemplates)[number]) => {
  const newEl: IConsentFormElement = {
    id: crypto.randomUUID(),
    type: template.type,
    label: template.label,
    required: false,
    options: [ConsentFormElementTypeEnum.Checkboxes, ConsentFormElementTypeEnum.MultipleChoice].includes(template.type)
      ? ['אפשרות 1']
      : undefined,
    content: template.type === ConsentFormElementTypeEnum.ReadOnly ? '' : undefined,
  };
  console.log('newEl', newEl);
  emit('selectedElement', newEl);
};
</script>

<style scoped lang="scss">

</style>
